import { INFORMATION_TYPE } from "@/types/enum/notification";

const titleDE = {
    locationData: 'Location erstellen',
    locationCreate: '@:titleRoute.locationData',
    locationDeliverer: 'Lieferant wählen',
    locationAdd: 'Location hinzufügen',
    locationJoin: 'Location beitreten',
    addLocationDeliverer: 'Lieferant hinzufügen',
    editLocationDeliverer: 'Lieferant bearbeiten',
    settingProfile: 'Profil',
    settingLocation: 'Location bearbeiten',
    settingOrder: 'Bestellung | Bestellungen',
    settingOrderDetail: 'Bestellungsdetails',
    settingTeam: 'Team',
    settingTeamInvite: 'Team einladen',
    settingDeliverer: 'Lieferanten',
    settingDelivererSelect: 'Lieferant wählen',
    settingNotification: 'Benachrichtigungen',
    settingDisplay: 'Darstellungsoptionen',
    settingSupport: 'Support',
    settingLegal: 'Rechtliches',
    cart: 'Warenkorb',
    orders: 'Bestellungen',
    filter: 'Filter',
    addList: 'Liste erstellen',
    editList: 'Liste bearbeiten',
    notificationDetails: '@:titleRoute.settingNotification',
    orderNotificationTimer: 'Bestellwecker',
    changePassword: 'Passwort ändern',
    addProduct: 'Produkt hinzufügen',
    editProduct: 'Produkt bearbeiten',
    agb: 'Datenschutzbestimmung',
    news: 'Octopus News',
    suggestion: 'Produktvorschlag',
    productDetails: 'Produktdetails',
    promotionDetails: 'Aktionsdetails',
    [INFORMATION_TYPE.PRODUCT_PRESENTATION]: '@:titleRoute.productDetails',
    [INFORMATION_TYPE.PROMOTION]: '@:titleRoute.promotionDetails',
    settingIntro: 'Apptour',
    feedback: 'Feedback erstellen',
    // language: 'Sprache',
    scanner: "Scanner",
    skipEmail: 'Email-Verifizierung',
    deleteLocations: 'Gelöschte Locations',
    aiCall: 'KI-Bestellung'
}

export default titleDE
